"use strict";
import React from "react";
import RouterContext from "../contexts/routerContext";
import { getLogoutUrl } from './../util/helpers';

const initComponent = (flex = window.flex) => {

    class Footer extends React.Component {
        static contextType = RouterContext;

        render() {
            const props = this.props || {};
            const appContext = props.appContext;
            const session = props.session;
            if (!appContext) return false;
            const navItems = flex.getNavsByPosition(props.appContext, "Footer");
            let footerNavItems = [];
            let footerMobileNavItems = [];
            if (session && session.isMobile)
                return false;

            const { Link } = this.context;
            const keyCheckExternalLinks = ["https://", "http://"];

            navItems.forEach((nav, index) => {
                footerNavItems.push(
                    keyCheckExternalLinks.some(key => nav.link.includes(key)) 
                    ? <li key={"footer-nav-" + index}>
                        <Link to={{ pathname: nav.link }}
                            target={"_blank"}
                            title={flex.text(nav.titleKey, nav.title)}
                        >
                            {flex.text(nav.labelKey, nav.label)}
                        </Link>
                    </li>
                    : <li key={"footer-nav-" + index}>
                        <Link to={nav.link} title={flex.text(nav.titleKey, nav.title)}>
                            {flex.text(nav.labelKey, nav.label)}
                        </Link>
                    </li>
                );
                if (nav.showInMobileView) {
                    footerMobileNavItems.push(<li className="xs-inline-block large" key={"footer-nav-mobile" + index}><Link to={nav.link} title={flex.text(nav.titleKey, nav.title)}>{flex.text(nav.labelKey, nav.label)}</Link></li>);
                }
            });

            if (session) {
                const logoutUrl = getLogoutUrl(flex);
                footerNavItems.push(<li key="footer-nav-logout"><Link to={logoutUrl}>Logout</Link></li>);
                footerMobileNavItems.push(<li key="footer-nav-mobile-logout" className="xs-inline-block large" ><Link to="/logout">Logout</Link></li>);
            }

            if (footerNavItems.length > 0) {
                footerNavItems.push(<li key="no-items"><hr /></li>);
            }


            const tempNav = appContext.nav || {};
            const tempNavs = tempNav.navs || [];

            const cssCustomProps = {
                '--ftr-columns': String(tempNavs.length)
            };

            const navs = tempNavs.map((nav, index) => {
                var subNavs = !nav.subNavs || !nav.subNavs.length ? false :
                    <ul className="subnav">
                        {nav.subNavs.map((subNav, subNavIndex) => { return <li key={nav.id + "-" + subNavIndex}><Link to={subNav.link}>{subNav.summary}</Link></li>; })}
                    </ul>;
                return (
                    <li key={"topnav-" + nav.id}>
                        <Link to={nav.link}>{nav.summary}</Link>
                        {subNavs}
                    </li>);
            });

            return (
                <footer className="page-footer" style={cssCustomProps}>
                    <div className="container container-fluid">
                        <div className="page-footer-nav-wrapper">
                            <div className="main-footer-nav xs-hidden print-hidden">
                                <nav id="nav-footer" className="nav footer-nav">
                                    <ul className="nav-list">
                                        {navs}
                                    </ul>
                                </nav>
                            </div>

                            <div className="sub-footer-nav">
                                <nav id="sub-nav-footer" className="nav footer-nav footer-sub-nav print-hidden">
                                    <ul className="nav-list">
                                        <li className="xs-hidden">
                                            <ul className="subnav">
                                                {footerNavItems}
                                            </ul>
                                        </li>
                                        {footerMobileNavItems}
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                    <div className="ftr-brand-bar"></div>
                </footer>
            );
        }
    }

    return Footer;
};

module.exports = initComponent;
